import {isForYouRefreshEnabled} from '../../shared/for-you-feature-flags'
import type {ForYouItemAction} from '../../shared/for-you-item.types'
import {useMergeabilityData} from '../use-mergeability-data'
import {OverviewMergeControl} from './OverviewMergeControl'
import {OverviewUpdateBranchControl, getBranchUpdateRequirement} from './OverviewUpdateBranchControl'

export function useOverviewBranchActions(itemName: string): ForYouItemAction[] {
  const data = useMergeabilityData()

  if (!isForYouRefreshEnabled() || !data || data.isClosedOrMerged) {
    return []
  }

  const actions = [
    {
      id: 'merge-control',
      content: <OverviewMergeControl data={data} itemName={itemName} />,
    },
  ]

  // update branch goes left of merge-control
  if (getBranchUpdateRequirement(data)) {
    actions.unshift({
      id: 'update-branch',
      content: <OverviewUpdateBranchControl itemName={itemName} />,
    })
  }

  return actions
}
